import { render } from "./CrmPaymentPairing.vue?vue&type=template&id=0767c626"
import script from "./CrmPaymentPairing.vue?vue&type=script&lang=js"
export * from "./CrmPaymentPairing.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__